import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homefourteen-about',
  templateUrl: './homefourteen-about.component.html',
  styleUrls: ['./homefourteen-about.component.scss']
})
export class HomefourteenAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
